const folderActionTypes =  {    
    RETRIEVED_OWNER_FOLDERS: "RETRIEVED_OWNER_FOLDERS",
    RETRIEVED_MODULE_FOLDERS: "RETRIEVED_MODULE_FOLDERS",
    RETRIEVED_MODULE_FILES: "RETRIEVED_MODULE_FILES",
    CREATED_NEW_OWNER_FOLDER: "CREATED_NEW_OWNER_FOLDER",
    CREATED_NEW_MODULE_FOLDER: "CREATED_NEW_MODULE_FOLDER"
};
export default folderActionTypes;